/* In-house reviews (Phase 3). Loads + submits reviews via the Plane 2 App Proxy. */
(function () {
  "use strict";
  var roots = document.querySelectorAll(".rv[data-product-id]");
  Array.prototype.forEach.call(roots, init);

  function stars(n) {
    var full = Math.round(n);
    var s = "";
    for (var i = 1; i <= 5; i++) s += i <= full ? "★" : "☆";
    return s;
  }
  function esc(t) {
    var d = document.createElement("div");
    d.textContent = t == null ? "" : String(t);
    return d.innerHTML;
  }

  // Signed review-request token from the invite email link (?review_token=...).
  var reviewTokenMatch = location.search.match(/[?&]review_token=([^&]+)/);
  var reviewToken = reviewTokenMatch ? decodeURIComponent(reviewTokenMatch[1]) : null;

  function init(root) {
    var productId = root.getAttribute("data-product-id");
    var path = root.getAttribute("data-reviews-path") || "/apps/ai/reviews";
    var listEl = root.querySelector(".rv-list");
    var avgNum = root.querySelector(".rv-avg-num");
    var avgStars = root.querySelector(".rv-stars");
    var countEl = root.querySelector(".rv-count");
    var moreBtn = root.querySelector(".rv-more");
    var form = root.querySelector(".rv-form");
    var msg = root.querySelector(".rv-msg");
    var page = 0;

    function load() {
      page += 1;
      fetch(path + "?product_id=" + encodeURIComponent(productId) + "&page=" + page, {
        headers: { Accept: "application/json" }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          if (page === 1 && data.aggregate) {
            avgNum.textContent = data.aggregate.count ? data.aggregate.average.toFixed(1) : "No reviews yet";
            avgStars.textContent = data.aggregate.count ? stars(data.aggregate.average) : "";
            countEl.textContent = data.aggregate.count
              ? "Based on " + data.aggregate.count + " review" + (data.aggregate.count === 1 ? "" : "s")
              : "Be the first to review this product.";
          }
          (data.reviews || []).forEach(function (rev) {
            var el = document.createElement("article");
            el.className = "rv-item";
            el.innerHTML =
              '<div class="rv-item-head"><span class="rv-item-stars">' + stars(rev.rating) + "</span>" +
              '<strong class="rv-item-author">' + esc(rev.authorName) + "</strong>" +
              (rev.verifiedPurchase ? '<span class="rv-verified">Verified</span>' : "") + "</div>" +
              (rev.title ? '<div class="rv-item-title">' + esc(rev.title) + "</div>" : "") +
              '<p class="rv-item-body">' + esc(rev.body) + "</p>";
            listEl.appendChild(el);
          });
          moreBtn.hidden = (data.reviews || []).length < 10;
        });
    }

    if (moreBtn) moreBtn.addEventListener("click", load);
    load();

    // Arrived from a review-invite link → open the form and confirm verification.
    if (reviewToken) {
      var det = root.querySelector(".rv-write");
      if (det) det.open = true;
      if (msg) msg.textContent = "Verified purchase — thanks for reviewing!";
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        var btn = form.querySelector(".rv-submit");
        btn.disabled = true;
        msg.textContent = "Submitting…";
        fetch(path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: productId,
            rating: Number(fd.get("rating")),
            authorName: fd.get("authorName"),
            authorEmail: fd.get("authorEmail") || null,
            title: fd.get("title") || null,
            body: fd.get("body"),
            reviewToken: reviewToken
          })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            btn.disabled = false;
            if (res.ok) {
              msg.textContent = res.j.message || "Thanks for your review!";
              form.reset();
              if (res.j.status === "published") { listEl.innerHTML = ""; page = 0; load(); }
            } else {
              msg.textContent = res.j.error === "rate_limited"
                ? "Please wait a moment before submitting again."
                : "Sorry — your review couldn't be submitted.";
            }
          })
          .catch(function () { btn.disabled = false; msg.textContent = "Network error — please try again."; });
      });
    }
  }
})();
